var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useEffect, useCallback, useContext, } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { LabelPrefixContextProvider, useListContext, useResourceContext, } from 'ra-core';
import { FormProvider, useForm, useFormContext, } from 'react-hook-form';
import lodashSet from 'lodash/set';
import lodashUnset from 'lodash/unset';
import lodashGet from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import { FilterFormInput } from './FilterFormInput';
import { FilterContext } from '../FilterContext';
export var FilterForm = function (props) {
    var defaultValues = props.defaultValues, filtersProps = props.filters, rest = __rest(props, ["defaultValues", "filters"]);
    var _a = useListContext(props), setFilters = _a.setFilters, displayedFilters = _a.displayedFilters, filterValues = _a.filterValues;
    var filters = useContext(FilterContext) || filtersProps;
    var mergedInitialValuesWithDefaultValues = mergeInitialValuesWithDefaultValues(defaultValues || filterValues, filters);
    var form = useForm({
        defaultValues: mergedInitialValuesWithDefaultValues,
    });
    // Reapply filterValues when the URL changes or a user removes a filter
    useEffect(function () {
        var newValues = getFilterFormValues(form.getValues(), filterValues);
        form.reset(newValues);
    }, [filterValues, form]);
    useEffect(function () {
        var subscription = form.watch(function (values, _a) {
            var name = _a.name, type = _a.type;
            return __awaiter(void 0, void 0, void 0, function () {
                var isFormValid, newValues;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, form.trigger()];
                        case 1:
                            isFormValid = _b.sent();
                            if (isFormValid) {
                                if (lodashGet(values, name) === '') {
                                    newValues = cloneDeep(values);
                                    lodashUnset(newValues, name);
                                    setFilters(newValues, displayedFilters);
                                }
                                else {
                                    setFilters(values, displayedFilters);
                                }
                            }
                            return [2 /*return*/];
                    }
                });
            });
        });
        return function () { return subscription.unsubscribe(); };
    }, [displayedFilters, form, setFilters]);
    return (React.createElement(FormProvider, __assign({}, form),
        React.createElement(FilterFormBase, __assign({ onSubmit: handleFormSubmit, filters: filters }, rest))));
};
export var FilterFormBase = function (props) {
    var className = props.className, filters = props.filters, rest = __rest(props, ["className", "filters"]);
    var resource = useResourceContext(props);
    var form = useFormContext();
    var _a = useListContext(props), _b = _a.displayedFilters, displayedFilters = _b === void 0 ? {} : _b, hideFilter = _a.hideFilter;
    useEffect(function () {
        filters.forEach(function (filter) {
            if (filter.props.alwaysOn && filter.props.defaultValue) {
                throw new Error('Cannot use alwaysOn and defaultValue on a filter input. Please set the filterDefaultValues props on the <List> element instead.');
            }
        });
    }, [filters]);
    var getShownFilters = function () {
        var values = form.getValues();
        return filters.filter(function (filterElement) {
            var filterValue = lodashGet(values, filterElement.props.source);
            return (filterElement.props.alwaysOn ||
                displayedFilters[filterElement.props.source] ||
                (filterValue !== '' && typeof filterValue !== 'undefined'));
        });
    };
    var handleHide = useCallback(function (event) { return hideFilter(event.currentTarget.dataset.key); }, [hideFilter]);
    return (React.createElement(LabelPrefixContextProvider, { prefix: "resources.".concat(resource, ".fields") },
        React.createElement(StyledForm, __assign({ className: className }, sanitizeRestProps(rest), { onSubmit: handleSubmit }),
            getShownFilters().map(function (filterElement) { return (React.createElement(FilterFormInput, { key: filterElement.props.source, filterElement: filterElement, handleHide: handleHide, resource: resource, className: FilterFormClasses.filterFormInput })); }),
            React.createElement("div", { className: FilterFormClasses.clearFix }))));
};
var handleSubmit = function (event) {
    event.preventDefault();
    return false;
};
FilterFormBase.propTypes = {
    resource: PropTypes.string,
    filters: PropTypes.arrayOf(PropTypes.node).isRequired,
    displayedFilters: PropTypes.object,
    hideFilter: PropTypes.func,
    initialValues: PropTypes.object,
    className: PropTypes.string,
};
var sanitizeRestProps = function (_a) {
    var displayedFilters = _a.displayedFilters, filterValues = _a.filterValues, hasCreate = _a.hasCreate, hideFilter = _a.hideFilter, setFilters = _a.setFilters, resource = _a.resource, props = __rest(_a, ["displayedFilters", "filterValues", "hasCreate", "hideFilter", "setFilters", "resource"]);
    return props;
};
export var mergeInitialValuesWithDefaultValues = function (initialValues, filters) { return (__assign(__assign({}, filters
    .filter(function (filterElement) {
    return filterElement.props.alwaysOn && filterElement.props.defaultValue;
})
    .reduce(function (acc, filterElement) {
    return lodashSet(__assign({}, acc), filterElement.props.source, filterElement.props.defaultValue);
}, {})), initialValues)); };
var handleFormSubmit = function () { };
var PREFIX = 'RaFilterForm';
export var FilterFormClasses = {
    clearFix: "".concat(PREFIX, "-clearFix"),
    filterFormInput: "".concat(PREFIX, "-filterFormInput"),
};
var StyledForm = styled('form', {
    name: PREFIX,
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            flex: '0 1 auto'
        },
        _b[theme.breakpoints.up('md')] = {
            flex: '0 1 100%',
        },
        _b.flexWrap = 'wrap',
        _b.alignItems = 'flex-end',
        _b.pointerEvents = 'none',
        _b.padding = "0 0 ".concat(theme.spacing(0.5), " 0"),
        _b['& .MuiFormHelperText-root'] = { display: 'none' },
        _b["& .".concat(FilterFormClasses.clearFix)] = { clear: 'right' },
        _b["& .".concat(FilterFormClasses.filterFormInput, " .MuiFormControl-root")] = {
            marginTop: "".concat(theme.spacing(1)),
        },
        _b);
});
/**
 * Because we are using controlled inputs with react-hook-form, we must provide a default value
 * for each input when resetting the form. (see https://react-hook-form.com/api/useform/reset).
 * To ensure we don't provide undefined which will result to the current input value being reapplied
 * and due to the dynamic nature of the filter form, we rebuild the filter form values from its current
 * values and make sure to pass at least an empty string for each input.
 */
export var getFilterFormValues = function (formValues, filterValues) {
    var _a;
    return Object.keys(formValues).reduce(function (acc, key) {
        acc[key] = getInputValue(formValues, key, filterValues);
        return acc;
    }, (_a = cloneDeep(filterValues)) !== null && _a !== void 0 ? _a : {});
};
var getInputValue = function (formValues, key, filterValues) {
    if (formValues[key] === undefined || formValues[key] === null) {
        return '';
    }
    if (Array.isArray(formValues[key])) {
        return lodashGet(filterValues, key, '');
    }
    if (formValues[key] instanceof Date) {
        return lodashGet(filterValues, key, '');
    }
    if (typeof formValues[key] === 'object') {
        return Object.keys(formValues[key]).reduce(function (acc, innerKey) {
            var _a;
            acc[innerKey] = getInputValue(formValues[key], innerKey, (_a = (filterValues || {})[key]) !== null && _a !== void 0 ? _a : {});
            return acc;
        }, {});
    }
    return lodashGet(filterValues, key, '');
};
//# sourceMappingURL=FilterForm.js.map